const STORAGE_KEY = "theme";
const LIGHT = "#f4f1ea";
const DARK = "#12110f";

function readStored(): "light" | "dark" | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === "light" || value === "dark" ? value : null;
  } catch {
    return null;
  }
}

function writeStored(theme: "light" | "dark") {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* private mode / blocked storage */
  }
}

function systemTheme(): "light" | "dark" {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function appliedTheme(): "light" | "dark" {
  const attr = document.documentElement.getAttribute("data-theme");
  if (attr === "light" || attr === "dark") return attr;
  return systemTheme();
}

function syncChrome(theme: "light" | "dark") {
  const color = theme === "dark" ? DARK : LIGHT;
  document.documentElement.style.colorScheme = theme;
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]:not([media])');
  if (meta) meta.content = color;
  const toggle = document.querySelector<HTMLButtonElement>("#theme-toggle");
  if (!toggle) return;
  const next = theme === "dark" ? "light" : "dark";
  toggle.setAttribute("aria-label", `Switch to ${next} mode`);
  toggle.setAttribute("aria-pressed", theme === "dark" ? "true" : "false");
  toggle.dataset.theme = theme;
}

export function setTheme(theme: "light" | "dark", persist: boolean) {
  document.documentElement.setAttribute("data-theme", theme);
  if (persist) writeStored(theme);
  syncChrome(theme);
}

export function initTheme() {
  const stored = readStored();
  if (stored) {
    document.documentElement.setAttribute("data-theme", stored);
  } else {
    document.documentElement.removeAttribute("data-theme");
  }
  syncChrome(appliedTheme());

  const toggle = document.querySelector<HTMLButtonElement>("#theme-toggle");
  toggle?.addEventListener("click", () => {
    setTheme(appliedTheme() === "dark" ? "light" : "dark", true);
  });

  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
    if (!readStored()) {
      document.documentElement.removeAttribute("data-theme");
      syncChrome(appliedTheme());
    }
  });
}
